import { useEffect, useState } from "react";
import { Spin } from "antd";
import logo from "../img/colorsSimple.png";

export type LoadingType = "circle" | "bubbles" | "spinner";

const COLORS = [
  "#73c3d3",
  "#f054a5",
  "#fadb14",
  "#95c11f",
  "#f68b1f",
];

interface Bubble {
  id: number;
  color: string;
  offset: { top: number; left: number };
}

interface AnimatedLogoProps {
  /** Тип загрузки: circle — круговой индикатор, bubbles — пузырьки, spinner — классический спиннер */
  loading?: LoadingType;
  size?: number;
  bubbleCount?: number;
  withBackground?: boolean;
  backgroundColor?: string;
}

const getRandomColor = () => COLORS[Math.floor(Math.random() * COLORS.length)];
const getRandomOffset = () => ({
  top: Math.random() * 100 - 50,
  left: Math.random() * 100 - 50,
});

function LoadingCircle({ size }: { size: number }) {
  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: "50%",
        border: `3px solid #e8e8e8`,
        borderTopColor: "#1890ff",
        animation: "spin 0.8s linear infinite",
      }}
    />
  );
}

function LoadingBubbles({
  size,
  bubbleCount,
  withBackground,
  backgroundColor,
}: {
  size: number;
  bubbleCount: number;
  withBackground: boolean;
  backgroundColor: string;
}) {
  const [bubbles, setBubbles] = useState<Bubble[]>([]);

  useEffect(() => {
    const interval = setInterval(() => {
      setBubbles((prev) => {
        const newBubble: Bubble = {
          id: Date.now(),
          color: getRandomColor(),
          offset: getRandomOffset(),
        };
        const updated = [...prev.slice(-bubbleCount + 1), newBubble];
        return updated;
      });
    }, 100);
    return () => clearInterval(interval);
  }, [bubbleCount]);

  return (
    <div style={{ position: "relative", width: size, height: size, margin: "0 auto 16px" }}>
      {bubbles.map((bubble) => (
        <div
          key={bubble.id}
          style={{
            position: "absolute",
            width: 14,
            height: 14,
            borderRadius: "50%",
            backgroundColor: bubble.color,
            top: `calc(50% + ${bubble.offset.top}px)`,
            left: `calc(50% + ${bubble.offset.left}px)`,
            transform: "translate(-50%, -50%)",
            opacity: 0.8,
            zIndex: 0,
          }}
        />
      ))}
      <div
        style={{
          width: size,
          height: size,
          borderRadius: "50%",
          backgroundColor: withBackground ? backgroundColor : "transparent",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 1,
          position: "relative",
        }}
      >
        <img
          src={logo}
          alt="logo"
          style={{ width: "60%", height: "60%", objectFit: "contain" }}
        />
      </div>
    </div>
  );
}

export default function AnimatedLogo({
  loading = "bubbles",
  size = 100,
  bubbleCount = 5,
  withBackground = false,
  backgroundColor = "#ccc",
}: AnimatedLogoProps) {
  switch (loading) {
    case "circle":
      return (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: size + 32 }}>
          <LoadingCircle size={size} />
          <style>{`
            @keyframes spin {
              to { transform: rotate(360deg); }
            }
          `}</style>
        </div>
      );
    case "spinner":
      return (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: 120 }}>
          <Spin size="large" />
        </div>
      );
    case "bubbles":
    default:
      return (
        <LoadingBubbles
          size={size}
          bubbleCount={bubbleCount}
          withBackground={withBackground}
          backgroundColor={backgroundColor}
        />
      );
  }
}
